export default {
  // 按钮
  addButton: '新增',
  editButton: '修改',
  deleteButton: '删除',
  cancelButton: '取消',
  confirmButton: '确定',

  // 搜索区域
  regionNameLabel: '区域名称',
  selectRegionPlaceholder: '请选择上级菜单',

  // 表格列
  accountNameColumn: '账号名称',
  loginAccountColumn: '登录账号',
  projectRegionColumn: '项目区域',
  createTimeColumn: '创建时间',
  actionColumn: '操作',

  // 表单标签
  projectRegionLabel: '项目区域',
  accountNameLabel: '账号名称',
  loginAccountLabel: '登录账号',
  loginPasswordLabel: '登录密码',
  userTypeLabel: '用户类型',
  workspaceLabel: '工作空间',
  mobileNumberLabel: '联系电话',
  roleNameLabel: '角色名称',
  statusLabel: '状态',

  // 表单placeholder
  selectRegionPlaceholder2: '请选择上级菜单',

  // 状态
  statusNormal: '正常',
  statusDisabled: '停用',

  // 验证消息
  accountNameRequired: '请输入账号名称',
  loginAccountRequired: '请输入登录账号',
  passwordRequired: '请输入密码',
  roleRequired: '请选择角色',
  workspaceRequired: '请选择工作空间',
  mobileNumberRequired: '请输入手机号',
  userTypeRequired: '请选择用户类型',
  regionRequired: '请选择区域',

  // 弹窗标题
  addAccountTitle: '新增账号',
  editAccountTitle: '编辑账号',

  // 成功消息
  addSuccess: '新增成功',
  editSuccess: '修改成功',
  deleteSuccess: '删除成功',

  // 确认对话框
  deleteConfirm: '是否删除 {username}',
}
